import { _TabEnabledMixin } from "../../../moreCore/_loadingHelpers/Tabbing";
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './communicationDisplayTable.html?raw';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';

import { CommunicationTypes } from "./conComTypes";

import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';

import communicationEditor from './communicationEditor';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';

class communicationDisplayTable extends compose(_TabEnabledMixin) {
    templateString: any = template;

    communicationObjectContainer: HTMLDivElement;
    communicationTable: MdsLax<InstanceType<typeof StaticTable>>;

    //der kontext wir u.a. beim erstellen neuer kommunikationsobjekte mitgegeben, dadurch kann die funktion bereits die objekte richtig referenzieren
    //comContext: Array<CommunicationTypes.ContextEntity>;


    //private refContext: ContextEntity;
    private contextEntities: Array<CommunicationTypes.ContextEntity> = [];
    private filterParams: Array<CommunicationTypes.FilterParams> = [];

    flagTableIsReady: boolean = false;
    flagIsWaitingForReady: boolean = false;

    /**
     * ContextEntities können ein oder mehrere Entities sein, zu denen die Liste ihre Kommunikationen lädt.
     * Filterparams
     * @param contextEntities
     * @param filterParams
     */
    setup(contextEntities?: Array<CommunicationTypes.ContextEntity>, filterParams?: Array<CommunicationTypes.FilterParams>): void {
        //this.refContext = contextEntity;
        //this.contextEntities = contextEntities;
        this.filterParams = lang.clone(filterParams);


        this.setContext(contextEntities);

    }

    reload(): void {
        this.updateDisplayData();
    }

    private mailTransmissions: Array<CommunicationTypes.emailTransmissionTableEntry> = [];

    private editWidgetRegestry: Record<string, { editor?: MdsLax<InstanceType<typeof communicationEditor>>, viewer?: MdsLax<InstanceType<typeof GenericEntityView>> }> = {};

    public readonly communicationStaticData: Record<string, { icon: string, floatLabel: string, floatGroupName: string, floatCallback: Function, checkRole: Array<string>, deletePermissionRole: string }> = {
        "email_transmission": {
            icon: "far fa-envelope-open",
            floatLabel: (this as any).translations["AddressWizard__NewBtn_Menu_Mail"],
            floatGroupName: "communications",
            floatCallback: null,
            checkRole: ["Email_Editor"],
            deletePermissionRole: "EMail_Editor"
        },

        "fallback": {
            icon: "far fa-comment-dots",
            floatLabel: null,
            floatGroupName: "communications",
            floatCallback: null,
            checkRole: [],
            deletePermissionRole: null,
        }
    };

    public getFloatEntrys() {
        let entrys: Array<{ callback: Function, icon: string, groupname: string, label: string }> = [];
        if (false) {
            for (const key in this.communicationStaticData) {
                if (key != 'fallback') {
                    let currentEntry = this.communicationStaticData[key];
                    let cb = null;
                    let canAddRecall = true;
                    //check rollen
                    for (let role of currentEntry.checkRole) {
                        if (this.hasUserRole(role) == false) {
                            canAddRecall = false;
                        }
                    }
                    if (canAddRecall) {
                        cb = lang.hitch(this, this._onCallback_AddNewEntry, key);
                    }
                    entrys.push({
                        callback: cb,
                        icon: currentEntry.icon,
                        groupname: "communications",
                        label: currentEntry.floatLabel,
                    });

                }
            }
        }
        return entrys;
    }

    public setContext(communicationContext: Array<CommunicationTypes.ContextEntity>) {
        this.contextEntities = communicationContext;
        if (this.helper_context_isReadyToDisplay() == true) {
            this.updateDisplayData();
        }
    }

    private _onCallback_SetTableData(response: CommunicationTypes.CommunicationApiResults) {
        this.flagIsWaitingForReady = false;
        this.mailTransmissions = response.email_transmissions;
        this.communicationTable.setData(response.email_transmissions);

        let hasEntries: boolean = false;
        if (response.email_transmissions?.length) hasEntries = true;

        this.emit("loaded", hasEntries);
    }

    private _onCallback_SetTableLayout(response: any) {
        if ((typeof response == 'undefined') || (response == null) || (typeof response != 'object')) {
            console.error("unable to set communication table layout");
            return;
        }
        this.communicationTable.setHeadingLabelFormatter(lang.hitch(this, this._tableFormatter_Headings));
        this.communicationTable.setFormatter(lang.hitch(this, this._tableFormatter_cells));
        this.communicationTable.setLayout(response[0]);
        this.communicationTable.setRowClick(lang.hitch(this, this._onClick_Rows));
        this.flagTableIsReady = true;
        this.updateDisplayData();
    }

    private _onCallback_AddNewEntry(selected: string) {
        //callfunction "Webtool_API__CommunicationHelpers_CreateNew" mit jsonData{type:string} -> return {ID:string, type:string}
        this.RequestManager.callfunction(
            "Webtool_API__CommunicationHelpers_CreateNew",
            { type: selected, contextData: this.contextEntities },
            lang.hitch(this, this._onCallback_CreatedNewCommunicationObject),
            lang.hitch(this, (err) => {
                console.error("unable to create new communication object", err);
                this.showToast((err as more.requestErrorMessage).Message, "far fa-dizzy");
            })
        );
    }

    private _onClick_Rows: StaticTable.rowclickCallback = function(row: StaticTable.StaticTableRow<any>, rowGroup: StaticTable.StaticTableRowGroup<any>, evt: Event ) {
        //oeffnen von entity view -> editor btn -> editor widget
        let targetID = rowGroup.entity["ID"];
        let targetType = rowGroup.entity["Classname"];
        let targetPrintname = rowGroup.entity["$ClassPrintname"];
        (this as any).openEntityViewDlg({ ID: targetID, type: targetType, printname: targetPrintname, entity: rowGroup.entity });
    }

    private _tableFormatter_Headings(displayName: string, propertyName: string) {
        if (propertyName == "$ClassPrintname") {
            if ((displayName == null) || (typeof displayName == 'undefined')) {
                return this.translations["General_Label_Type"];
            }
            return false;
        }
        return false;
    }

    private _tableFormatter_cells(cell: StaticTable.StaticTableCell<any>) {
        let targetClassType = cell.entity["Classname"];
        switch (cell["name"]) {
            case '$ClassPrintname':
                let parentDiv = document.createElement('span');
                let targetIcon = this.communicationStaticData["fallback"].icon;
                let iconElement = document.createElement('i');
                if (this.communicationStaticData.hasOwnProperty(targetClassType)) {
                    targetIcon = this.communicationStaticData[targetClassType].icon;
                }
                iconElement.setAttribute("class", targetIcon);
                parentDiv.appendChild(iconElement);
                let txtLabel = document.createElement('label');
                txtLabel.innerHTML = cell.value;
                txtLabel.style.paddingLeft = "5px";

                if (cell.entity["sent"] !== true) {
                    txtLabel.innerHTML = txtLabel.innerHTML + " (Entwurf)";
                }

                parentDiv.appendChild(txtLabel);
                cell.contentnode.insertBefore(parentDiv, cell.contentnode.firstChild);
                return true;
                break;
            /*case 'ModificationDate':
                let dateLabel = document.createElement('span');
                dateLabel.style.fontStyle = "italic";
                let d = new Date(cell.value * 1000);
                dateLabel.innerHTML = d.toLocaleString();
                cell.contentnode.appendChild(dateLabel);
                return true;
                break;*/
            case 'TransmissionDate':
                let dateLabel2 = document.createElement('span');
                dateLabel2.style.fontStyle = "italic";
                let d2 = new Date(cell.value * 1000);
                dateLabel2.innerHTML = d2.toLocaleString();
                cell.contentnode.appendChild(dateLabel2);
                return true;
                break;
            case 'description':
                if ((typeof cell.value == 'undefined') || (cell.value == null) || (cell.value == "")) {
                    cell.value = " "; //um default formatter aufzuhalten :O
                    let spanElem = document.createElement('span');
                    spanElem.classList.add("italic");
                    spanElem.innerHTML = this.translations["Generic__no_Description"];
                    cell.contentnode.appendChild(spanElem);
                    return true;
                }
            default:
                break;
        }
        return false;
    }

    private async _onCallback_CreatedNewCommunicationObject(resp: { type: string, ID: string, printname: string }) {
        await this.waitForUpdate();
        //wir oeffnen den editor
        //user rechte wurden bereits beim einfuegen im floating gesetzt
        this._onCallback_CommunicationView_OpenEditor(resp);
    }

    private openEntityViewDlg(data: { type: string, ID: string, printname: string, entity: ApiEntity }) {
        let newViewer: MdsLax<InstanceType<typeof GenericEntityView>>;

        if (this.editWidgetRegestry.hasOwnProperty(data.ID) == true) {
            if ((typeof this.editWidgetRegestry[data.ID].viewer != 'undefined') && (this.editWidgetRegestry[data.ID].viewer != null)) {
                newViewer = this.editWidgetRegestry[data.ID].viewer; //wir sollten den viewer destroyen und neu aufbauen
                try {
                    newViewer.destroyRecursive();
                } catch {
                    console.warn("cannot destroy generic entity viewer (communication object display)");
                }
                this.editWidgetRegestry[data.ID].viewer = undefined;
            }
        }

        newViewer = new GenericEntityView();
        this.editWidgetRegestry[data.ID] = {};
        this.editWidgetRegestry[data.ID]["viewer"] = newViewer;
        newViewer.setup(
            data.ID,
            data.type,
            null,
            null,
            null,
            null,
            "communicationDisplayTable"
        );
        newViewer.setDeletePrivilege(this.communicationStaticData[data.type].deletePermissionRole);
        newViewer.on("deleted", lang.hitch(this, () => {
            this.updateDisplayData(); //nach delete neu laden
        }));
        newViewer.on("closed", lang.hitch(this, () => {
            this.updateDisplayData(); //nach delete neu laden
        }));
        //wir fuegen ein edit button ein, wenn die rechte vorhanden sind
        let hasRoles = false;
        if (this.communicationStaticData.hasOwnProperty(data.type)) {
            hasRoles = true;//wir setzen default true und checken dann alle rollen, wenn eine rolle nicht vorhanden ist dann alles falsch
        }
        for (let role of this.communicationStaticData[data.type].checkRole) {
            if (this.hasUserRole(role) == false) {
                hasRoles = false;
            }
        }

        //console.log("entity data", data.entity);

        if (hasRoles && data.entity["sent"] !== true) {
            newViewer.addButton(
                "editBtn",
                this.translations["General_Edit"],
                lang.hitch(this, this._onCallback_CommunicationView_OpenEditor, data),
                this.translations["General_Edit"],
                "mds-button-base w3-padding round hoverBright accentBG",
                "fas fa-edit",
                true,
                'last',
                true
            );

            newViewer.addButton(
                "deleteBtn",
                this.translations["General_Delete"],
                lang.hitch(this, this._onCallback_CommunicationView_Delete, data.entity["ID"], data.entity["description"]),
                this.translations["General_Delete"],
                "mds-button-base w3-padding round hoverBright accentBG",
                "fas fa-trash warningTXT",
                true,
                'last',
                true
            );
        }

        newViewer.showAsDlg(data.ID, this.translations["Generic__view"]);
    }

    private _onCallback_CommunicationView_Delete(ID: string, description: string): void {
        let dlg = new GenericDialog();

        dlg.show(
            this.translate("General_ConfirmDeleteMessage"),
            description,
            this.translate("General_ConfirmDeleteSubtitle"),
            "fas fa-exclamation-triangle",
            "yesno",
            lang.hitch(this, this._onConfirmDeletion, ID)
        );
    }

    private _onConfirmDeletion(entityID: string, result: number) {
        if (result >= 2) // ja
        {
            this.StandbyStart();
            this.RequestManager.callfunction("Webtool_API_EmailTransmission__Delete", { "ID": entityID }, lang.hitch(this, this._onDeleteResponse), lang.hitch(this, this._onDeleteError), true);
        }
    }

    private _onDeleteResponse(response) {
        this.StandbyStop();

        this.reload();
    }

    private _onDeleteError(error: more.requestErrorMessage) {
        this.StandbyStop();

        alert(error.Message);
    }

    private _onCallback_CommunicationView_OpenEditor(data: { type: string, ID: string, printname: string }) {
        if (this.editWidgetRegestry.hasOwnProperty(data.ID) == false) { //falls es den record eintrag nicht gibt aus welchen gruenden auch immer
            this.editWidgetRegestry[data.ID] = {};
        }
        if (this.editWidgetRegestry[data.ID].hasOwnProperty("editor")) {
            if ((typeof this.editWidgetRegestry[data.ID].editor != 'undefined') && (this.editWidgetRegestry[data.ID].editor != null)) {
                try {
                    this.editWidgetRegestry[data.ID].editor.destroyRecursive();
                } catch (err) {
                    console.warn("unable to destroy communication editor", err);
                }
            }
        }
        this.editWidgetRegestry[data.ID].editor = new communicationEditor(data.ID, data.type, data.printname);
        this.emit("requestEditor", this.editWidgetRegestry[data.ID].editor);
        this.editWidgetRegestry[data.ID].editor.on("saved", lang.hitch(this, this.updateDisplayData)); //wir handlen event zum editor direkt hier im widget
        this.editWidgetRegestry[data.ID].editor.on("closed", lang.hitch(this, this.updateDisplayData));
    }

    public updateDisplayData() {
        this.waitForUpdate();
    }



    private async waitForUpdate() {
        if (this.flagIsWaitingForReady == true) {
            return;
        }
        this.flagIsWaitingForReady = true;
        let promise = this.helper_waitForDataFetchReady();

        promise.then(lang.hitch(this, function () {
            this.RequestManager.callfunction(
                "Webtool_API_CommunicationHelpers__GetCommunication_Table_Data",
                {
                    //refContext: this.refContext,
                    contextEntities: this.contextEntities,
                    filterParams: this.filterParams
                },
                lang.hitch(this, this._onCallback_SetTableData),
                lang.hitch(this, (err: more.requestErrorMessage) => {
                    console.error("error retrieving communication table data", err);
                    this.showToast(err.Message, "far fa-dizzy");
                    if (this.flagTableIsReady == true) {
                        this.communicationTable.setData([]);
                    }
                    this.flagIsWaitingForReady = false;
                    return;
                })
            );
        }));
    }

    constructor(context?: CommunicationTypes.ContextEntity) {
        super(...(arguments as unknown as []));
        if (context) {
            if (context["ID"] && context["Classname"]) {
                this.contextEntities = [context];
            }
        }
    }
    public hasEntries(): boolean {
        return this.communicationTable.getRowCount() != 0;
    }
    postCreate(): void {
        this.communicationTable = new StaticTable();
        this.communicationTable.on("tableDrawn", lang.hitch(this, this.emit, "contentChange"));
        this.communicationTable.placeAt(this.communicationObjectContainer);
        this.communicationTable.setCyAttribute("communicationDisplay");
        this.RequestManager.callfunction(
            "Webtool_API_CommunicationHelpers__GetCommunication_Table_Layout",
            "",
            lang.hitch(this, this._onCallback_SetTableLayout),
            (err) => {
                console.error("unable to fetch table layout for communication table...", err);
                this.showToast((err as more.requestErrorMessage).Message, "far fa-dizzy");
            }
        );
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    private helper_context_isReadyToDisplay(): boolean {
        let res = false;
        if (typeof this.contextEntities != 'undefined') {
            if (this.contextEntities != null) {
                if (typeof this.contextEntities == 'object') {
                    if (this.contextEntities.length > 0) {
                        res = true;
                    }
                }
            }

            if (!res) {
                res = this.filterParams?.length > 0;
            }
        }
        return res;
    }

    private waitForReadyInterval: any; //interval ist als feld damit wir es im destroy notfalls auch clearen koennen
    private helper_waitForDataFetchReady(): Promise<any> {
        //wir warten basically dass der context gesetzt wird....
        return new Promise((resolve) => {
            // wennn alles ready ist dann sind wir auch sofort bereit
            if (this.flagTableIsReady) {
                if (this.contextEntities?.length || this.filterParams?.length) {
                    resolve(this.flagTableIsReady);
                    return;
                }
            }

            // wenn nicht checken wir alle x ms ob wir bereit sind
            this.waitForReadyInterval = setInterval(() => {
                if (this.flagTableIsReady) {
                    if (this.contextEntities?.length || this.filterParams?.length) {
                        clearInterval(this.waitForReadyInterval);
                        resolve(this.flagTableIsReady);
                    }
                }
            }, 75);
        });
    }

    destroy(): void {
        try {
            clearInterval(this.waitForReadyInterval);
        } catch {
            /* wir probieren eigentlich nur das interval zu clearen um memory leaks zu verhindern... */
        }
        super.destroy.apply(this, arguments as any);
    }

}

export default mdsWidget(communicationDisplayTable);
